import type React from 'react';
import { Link, type LinkProps } from 'react-router-dom';

import styled from '@emotion/styled';

import { buttonAppearance, type ButtonSize, type ButtonVariant } from './utils/button_appearance';

export type ButtonLinkProps = {
  variant?: ButtonVariant;
  size?: ButtonSize;
  to: LinkProps['to'];
} & Omit<React.ComponentPropsWithoutRef<typeof Link>, 'to' | 'variant' | 'size'>;

/** In-app navigation. Default = text link; set `variant` + optional `size` for button chrome. */
export const ButtonLink = styled(Link, {
  shouldForwardProp: (prop) => prop !== 'variant' && prop !== 'size',
})<ButtonLinkProps>`
  ${({ variant = 'link', size }) => buttonAppearance({ variant, size })}
`;

export type ExternalButtonLinkProps = {
  variant?: ButtonVariant;
  size?: ButtonSize;
} & React.AnchorHTMLAttributes<HTMLAnchorElement>;

/** External http(s) links with button chrome (full navigation, e.g. Storage Treasures). */
export const ExternalButtonLink = styled('a', {
  shouldForwardProp: (prop) => prop !== 'variant' && prop !== 'size',
})<ExternalButtonLinkProps>`
  ${({ variant = 'secondary', size = 'default' }) => buttonAppearance({ variant, size })}
  display: inline-flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
`;
